import * as React from "react";
import { FastField } from "formik";
import { FormGroup } from "../../../../../../../../libs/components/libs/form/group/index";
import { Button } from "../../../../../../../../libs/components/libs/button/index";
import { RotateLoader } from "../../../../../../../../libs/components/libs/loaders/rotate/index";
import {Switch} from "../../../../../../../../libs/components/libs/form/switch/Switch";
import {MobxComponent} from "../../../../../../../mobx/components/index";
import {inject, observer} from "mobx-react";
import {RestaurantForm} from "../../../../../../../mobx/components/restaurant-form";
import {UI} from "../../../../../../../core/ui";
import {PaymentBaseFields} from "./base";

interface Props {
    payment_id: string;
}
interface State {}
type FormValues = RestaurantSchema["settings"]["payments"]["custom"];

@inject("store") @observer
export class SettingsFormPaymentsCustom extends MobxComponent<Props, State> {

  initialValues: FormValues;

  constructor(props: Props) {
    super(props);
    this.state = {};
    const r = this.injected.store.restaurant!;
    this.initialValues = r.settings.payments[props.payment_id];
  }

  render() {
    const { payment_id } = this.props;
    return (
      <RestaurantForm<FormValues>
        submit={async (r, values) => {
          r.settings.payments[payment_id] = values;
          const update = { $set: { [`settings.payments.${payment_id}`]: values } };
          return { r, update };
        }}
        validators={{}}
        initialValues={this.initialValues}
        onSuccess={() => {}}
        onError={() => UI.notification.error("An error occurred")}
        onSuccessMessage="Settings Updated"
        onErrorMessage="">
        {({ form, error }) => {
          const { isSubmitting, setFieldValue } = form;
          return (
            <div className="p-4">

              <FastField
                name="enabled"
                render={({ field }: any) => (
                  <FormGroup
                    title="Enabled"
                    help="Allows customers to pay using this method">
                    <Switch
                      id="enable-switch"
                      checked={field.value}
                      onChange={(e) => setFieldValue("enabled", e.target.checked)}/>
                  </FormGroup>
                )}
              />

              <PaymentBaseFields
                requireLabel={true}
                setFieldValue={setFieldValue}
              />

              {error && <FormGroup error={error}/>}

              <Button full={true} color="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting && <RotateLoader size={2} color="white"/>}
                {!isSubmitting && "Save"}
              </Button>

            </div>
          );
        }}
      </RestaurantForm>
    );

  }

}
